module.exports = __webpack_public_path__ + "static/img/方案策划-创意方案.4f6b378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10008/方案策划-创意方案.png
// module id = H4S3
// module chunks = 1